import { Document, Page, Font, StyleSheet, Text, View, Image } from '@react-pdf/renderer';
import { isEmpty } from 'lodash-es';
import { getDateUsingFormat } from 'wisestep-base';

import Mginternational from '../../../../images/Mginternational.jpg';
import { IInvoicePdf } from '../../types/IInvoicePdf';
import { InvoiceTemplate } from '../InvoiceTemplateForm';

export const MgInterntionalPdf = ({
  fileUrl,
  fetchPreviewDetails,
  raisedDate,
  invoiceCode,
  dueDate,
  candidateList,
  total,
  amountInWord,
  description,
  subTotal,
  totalBeforeTaxation,
  selectedInvoiceTaxFields,
  taxation,
  selectedAdditionalTaxFields,
  adjustment,
  termsAndConditions,
  invoiceCurrency,
  invoiceExtras,
  discount,
  discountToggle,
  tabular,
  showCompensationFeeArr,
  jobTitle,
}) => (
  <MgInternationalPreview
    invoice={{
      invoiceTypeName: fetchPreviewDetails.clientInvoiceTypeName,
      ourEntityLegalIdentifier: fetchPreviewDetails.ourEntityLegalIdentifier,
      ourEntity: {
        Legal_Name: fetchPreviewDetails.ourEntityLegalName,
        Registered_address: fetchPreviewDetails.ourEntityAddress,
        Corporate_address: fetchPreviewDetails.ourEntityCorporateAddress,
        Name: fetchPreviewDetails.ourEntityName,
      },
      ourEntityBank: {
        bankName: fetchPreviewDetails.bankName,
        swiftCode: fetchPreviewDetails.bankSwiftCode,
        branchName: fetchPreviewDetails.bankBranch,
        bankAccountNumber: fetchPreviewDetails.bankAccountNumber,
        iban: fetchPreviewDetails.bankIban,
        bankCode: fetchPreviewDetails.bankCode,
      },
      client: {
        legalName: fetchPreviewDetails.clientLegalName,
        address: fetchPreviewDetails.clientAddress,
        name: fetchPreviewDetails.clientName,
      },
      raisedDate,
      invoiceCode,
      dueDate,
      currency: invoiceCurrency,
      total,
      amountInWord,
      description,
      subTotal,
      taxation,
      adjustment,
      termsAndConditions,
      descriptive: !tabular,
      showCompensationFeeArr,
      extras: fetchPreviewDetails.invoiceExtras,
      discount,
      discountToggle,
      candidateList,
      invoiceExtras,
      totalBeforeTaxation,
      selectedInvoiceTaxFields,
      selectedAdditionalTaxFields,
      jobTitle,
    }}
    fileUrl={fileUrl}
  />
);

interface MgInternationalProps {
  template?: InvoiceTemplate;
  invoice: IInvoicePdf;
  fileUrl?: string;
  tabular?: boolean;
}
export const MgInternationalPreview = ({ invoice }: MgInternationalProps) => {
  const { selectedInvoiceTaxFields } = invoice;
  return (
    <Document>
      <Page size="A4" wrap style={styles.page}>
        <View style={styles.container}>
          <Image src={Mginternational} style={styles.backgroundImage} />
          <View style={styles.border}>
            <View style={styles.container}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{`Party's`}</Text>
                    <Text style={styles.tableCell}>A/C</Text>
                  </View>
                  <View style={styles.secondColumn}>
                    <Text style={styles.tableCell}>
                      Client : {!isEmpty(invoice?.client?.name) ? invoice.client.name : ''}
                    </Text>
                    <Text style={{ top: 20, fontSize: 12, left: 4 }}>{invoice.client.address}</Text>
                    <Text style={{ top: 28, fontSize: 12, left: 4 }}>
                      {' '}
                      {!isEmpty(invoice.ourEntityLegalIdentifier) &&
                        invoice.ourEntityLegalIdentifier.map((legalValue, index) => (
                          <Text style={styles.tableCell2} key={index}>
                            {legalValue.legalIdentifierName ?? ''}:{legalValue.value ?? ''}
                            {'\n'}
                          </Text>
                        ))}
                      <Text style={{ top: 70, fontSize: 12, left: 4 }}>State Code:</Text>
                      {'\n'}
                      <Text style={{ top: 80, fontSize: 12, left: 50 }}>State : </Text>
                      <Text style={styles.tableCell2}> </Text>
                    </Text>
                  </View>
                  <View style={styles.thirdColumn}>
                    <Text style={{ left: 50, fontSize: 13, top: 13 }}>
                      {invoice.invoiceTypeName}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.tableRow3}>
                <View style={styles.invoiceNo}>
                  <Text style={styles.tableCell3}>Invoice no.</Text>
                </View>
                <View style={styles.tableCo8}>
                  <Text style={styles.tableCell3}>{invoice.invoiceCode}</Text>
                </View>
              </View>
              <View style={styles.tableRow3}>
                <View style={styles.date}>
                  <Text style={styles.tableCell3}>Date</Text>
                </View>
                <View style={styles.dateValue}>
                  <Text style={styles.tableCell3}>{invoice.raisedDate}</Text>
                </View>
              </View>
              <View style={styles.table1}>
                <View style={styles.tableColumn}></View>
              </View>
            </View>
            <View style={styles.container}>
              <View style={styles.tableheading}>
                <View style={styles.srNo}>
                  <Text style={styles.headingText}>Sr.no</Text>
                </View>
                <View style={styles.particulars}>
                  <Text style={styles.headingText}>Particulars</Text>
                </View>
                <View style={styles.tableCol5}>
                  <Text style={styles.headingText}>DOJ</Text>
                </View>
                <View style={styles.tableCol5}>
                  <Text style={{ top: 3, fontSize: 12, left: 2, fontFamily: 'Times-Roman' }}>
                    Rate
                  </Text>
                  <Text style={{ top: 3, fontSize: 12, left: 2, fontFamily: 'Times-Roman' }}>
                    Applied
                  </Text>
                </View>
                <View style={styles.amount}>
                  <Text style={{ left: 65, fontSize: 12, top: 13 }}>Amount(Rs)</Text>
                </View>
              </View>

              {invoice.items && invoice.items?.length > 0
                ? invoice.items?.map(
                    (item, index) =>
                      item.closure && (
                        <View style={styles.tableData} key={index}>
                          <View style={styles.sequence}>
                            <Text style={{ top: 28, fontSize: 11, left: 25 }}>{index + 1}</Text>
                          </View>
                          <View style={styles.particularsValue}>
                            <Text style={{ top: 2, fontSize: 11, left: 20 }}>Placement Fee </Text>
                            <Text style={{ top: 13, fontSize: 11, left: 6 }}>
                              {item?.closure.candidate?.name}
                            </Text>
                            <Text
                              style={{ top: 13, fontSize: 11, left: 6, fontFamily: 'Times-Roman' }}
                            >
                              {invoice.jobTitle}
                            </Text>
                            <Text style={{ top: 13, fontSize: 11, left: 6 }}>
                              {`CTC ${invoice.currency?.symbol ?? ''} ${
                                item.closure?.compensationAmount
                              }`}
                            </Text>
                            {selectedInvoiceTaxFields &&
                              selectedInvoiceTaxFields.map((taxObj) => (
                                <Text
                                  style={{
                                    top: 13,
                                    fontSize: 11,
                                    left: 6,
                                    fontFamily: 'Times-Roman',
                                  }}
                                  key={taxObj.id}
                                >
                                  {taxObj.name}
                                  {'\n'}
                                </Text>
                              ))}
                          </View>
                          <View style={styles.doj}>
                            <Text
                              style={{ top: 27, fontSize: 11, left: 6, fontFamily: 'Times-Roman' }}
                            >
                              {item?.closure.joiningDate != undefined
                                ? getDateUsingFormat(
                                    item?.closure.joiningDate?.toString(),
                                    'DD/MM/YYYY'
                                  )
                                : ''}
                            </Text>
                          </View>
                          <View style={styles.doj}>
                            <Text
                              style={{ top: 27, fontSize: 10, left: 10, fontFamily: 'Times-Roman' }}
                            >
                              {item?.closure?.feeArrangementAmount}
                            </Text>

                            {selectedInvoiceTaxFields &&
                              selectedInvoiceTaxFields.map((taxObj) => (
                                <Text
                                  style={{
                                    top: 60,
                                    fontSize: 11,
                                    left: 10,
                                    fontFamily: 'Times-Roman',
                                  }}
                                  key={taxObj.id}
                                >
                                  {`${taxObj.rate}  %`}
                                  {'\n'}
                                </Text>
                              ))}
                          </View>
                          <View style={styles.amountValue}>
                            <Text
                              style={{ top: 25, fontSize: 11, left: 82, fontFamily: 'Times-Roman' }}
                            >
                              {item?.closure?.commissionValue}
                            </Text>
                            {selectedInvoiceTaxFields &&
                              selectedInvoiceTaxFields.map(
                                (taxObj) =>
                                  item?.closure?.commissionValue != undefined && (
                                    <Text
                                      style={{
                                        top: 60,
                                        fontSize: 11,
                                        left: 82,
                                        fontFamily: 'Times-Roman',
                                      }}
                                      key={taxObj.id}
                                    >
                                      {(item?.closure?.commissionValue * parseInt(taxObj.rate)) /
                                        100}
                                      {'\n'}
                                    </Text>
                                  )
                              )}
                          </View>
                        </View>
                      )
                  )
                : ''}

              <View style={styles.tableTotal}>
                <View style={styles.totalAmount}>
                  <Text style={styles.tableCellTotal}>Total</Text>
                </View>
                <View style={styles.totalValue}>
                  <Text style={styles.tableCellTotalValue}>{invoice.total}</Text>
                </View>
              </View>
              <View style={styles.tableWords}>
                <View style={styles.inWords}>
                  <Text style={styles.headingText}>In Words</Text>
                </View>
                <View style={{ marginBottom: 77 }}>
                  <Text style={styles.headingText}>{invoice.amountInWord}</Text>
                </View>
              </View>
            </View>
            <View style={styles.container}>
              <View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>Subject to Kochi Jurisdiction </Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>
                    {`Payment by RTGS or A/C Payee's Cheque only in the name of "MG International"`}
                  </Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>Bank Account details:</Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>
                    Beneficiary Name: {invoice?.ourEntity.Legal_Name}
                  </Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>
                    A/c No.: {invoice.ourEntityBank.bankAccountNumber}
                  </Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>Bank Name: {invoice.ourEntityBank.bankName}</Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>IFSC Code: {invoice.ourEntityBank.bankCode}</Text>
                </View>
                <View style={{ bottom: 87 }}>
                  <Text style={styles.tableCell3}>
                    Branch Address: {invoice.ourEntityBank.branchName}
                  </Text>
                </View>

                <View style={{ bottom: 80 }}>
                  <Text style={styles.tableCell3}>
                    {!isEmpty(invoice.ourEntityLegalIdentifier) ? (
                      invoice.ourEntityLegalIdentifier.map((legalValue, index) => (
                        <Text style={styles.tableCell2} key={index}>
                          {legalValue.legalIdentifierName ?? ''}:{legalValue.value ?? ''}
                          {'\n'}
                        </Text>
                      ))
                    ) : (
                      <Text style={styles.tableCell2}>{'\n'}</Text>
                    )}
                  </Text>
                </View>
                <View style={{ bottom: 75 }}>
                  <Text style={styles.tableCell3}>Nature of service:</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
});

const styles = StyleSheet.create({
  body: {
    position: 'relative',
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    zIndex: 5,
  },
  page: {
    flexDirection: 'column',
    backgroundColor: 'white',
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
  },
  border: {
    borderStyle: 'solid',
    borderWidth: 0,
    borderColor: '#00000',
    height: '100%',
    padding: 32,
  },
  table: {
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 27,
  },
  title: {
    fontSize: 15,
    paddingTop: 50,
    textAlign: 'center',
    fontFamily: 'Oswald',
  },
  author: {
    fontSize: 13,
    textAlign: 'center',
    marginBottom: 1,
    fontFamily: 'Oswald',
  },
  text: {
    margin: 12,
    fontSize: 1,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'right',
    color: 'grey',
  },
  tableCol: {
    width: '15%',
    borderStyle: 'solid',
    height: 40,
    borderWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    fontFamily: 'Oswald',
    top: 33,
    left: 7,
  },
  secondColumn: {
    width: '230',
    borderStyle: 'solid',
    height: 180,
    borderWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    fontFamily: 'Oswald',
    top: 33,
    left: 7,
  },
  tableColumn: {
    width: '15%',
    borderStyle: 'solid',
    height: 145.5,
    borderWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    bottom: 79,
    left: 7,
  },
  tableCell: {
    marginTop: 3,
    fontSize: 11,
    left: 5,
    fontFamily: 'Oswald',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  thirdColumn: {
    width: '200',
    borderStyle: 'solid',
    height: 180,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    fontFamily: 'Oswald',
    top: 33,
    left: 7,
  },
  tableCo8: {
    width: '120',
    height: '29',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 1,
    bottom: 45,
    marginRight: 0,
  },

  invoiceNo: {
    width: '80',
    height: '30',
    alignItems: 'flex-start',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    bottom: 45,
  },
  date: {
    width: '80',
    height: '30',
    alignItems: 'flex-start',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    bottom: 36,
  },
  dateValue: {
    width: '120',
    height: '30',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
    bottom: 36,
    marginRight: 0,
  },
  srNo: {
    width: '77.9',
    borderStyle: 'solid',
    maxHeight: 30,
    borderWidth: 1,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    fontFamily: 'Oswald',
  },
  inWords: {
    width: '78',
    borderStyle: 'solid',
    height: 31,
    borderWidth: 1,
    top: 0,
    borderBottomWidth: 1,
    fontSize: 10,
    fontFamily: 'Oswald',
  },
  particulars: {
    width: '30%',
    borderStyle: 'solid',
    height: 30,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    fontFamily: 'Oswald',
  },
  amount: {
    width: '24.5%',
    borderStyle: 'solid',
    height: 30,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    fontFamily: 'Oswald',
  },
  sequence: {
    width: '77.9',
    borderStyle: 'solid',
    height: 155,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    fontFamily: 'Oswald',
  },
  particularsValue: {
    width: '30%',
    borderStyle: 'solid',
    height: 155,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 1,
    fontFamily: 'Oswald',
  },
  tableCol5: {
    width: '14.8%',
    borderStyle: 'solid',
    height: 30,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderTopWidth: 0,
    fontFamily: 'Oswald',
  },
  doj: {
    width: '14.8%',
    borderStyle: 'solid',
    height: 155,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    fontFamily: 'Oswald',
  },
  amountValue: {
    width: '24.5%%',
    borderStyle: 'solid',
    height: 155,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: '1',
    fontFamily: 'Oswald',
  },
  headingText: {
    marginTop: 10,
    left: 25,
    fontSize: 12,
    fontFamily: 'Oswald',
  },
  tableCell2: {
    left: 25,
    fontSize: 11,
    fontFamily: 'Oswald',
    display: 'flex',
  },
  tableCell3: {
    paddingLeft: 3,
    fontSize: 11,
    fontFamily: 'Oswald',
    top: 3,
  },
  tableCellTotalValue: {
    paddingLeft: 3,
    fontSize: 11,
    fontFamily: 'Oswald',
    top: 4,
    left: 81,
  },
  tableCellTotal: {
    paddingLeft: 3,
    fontSize: 11,
    fontFamily: 'Oswald',
    top: 4,
    left: 14,
  },
  extraText: {
    marginBottom: 7,
    paddingLeft: 3,
    fontSize: 11,
    fontFamily: 'Times-Roman',
    fontWeight: 'hairline',
  },
  totalAmount: {
    width: '95',
    height: '23',
    alignItems: 'flex-start',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderRightWidth: 0,
  },
  totalValue: {
    width: '160',
    height: '23',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 1,
    borderBottomWidth: 0,
    marginRight: 0,
    left: 4,
  },
  tableRow: {
    flexDirection: 'row',
    width: 510,
    height: 180,
  },
  table1: {
    flexDirection: 'row',
    width: 510,
    height: 141,
  },
  Row1: {
    flexDirection: 'row',
    width: 510,
  },
  tableRow1: {
    flexDirection: 'row',
    width: 489,
    bottom: '196',
  },
  tableheading: {
    flexDirection: 'row',
    width: 510,
    height: 50,
    left: 7,
    bottom: 20,
  },
  tableWords: {
    flexDirection: 'row',
    width: 510,
    left: 6.6,
    bottom: 15,
  },
  tableData: {
    flexDirection: 'row',
    width: 510,
    bottom: '30',
    left: 7,
  },
  tableRow01: {
    flexDirection: 'row',
    width: 510,
    bottom: '100',
  },
  tableRow2: {
    flexDirection: 'row',
    width: '500',
    paddingLeft: 300,
    bottom: '40',
  },
  tableRow3: {
    flexDirection: 'row',
    width: '500',
    left: 309,
  },
  tableTotal: {
    flexDirection: 'row',
    width: '500',
    paddingLeft: 309,
    bottom: 17,
  },
});

export default MgInternationalPreview;
